import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';

var SvgSpa = function SvgSpa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
    fill: "#F2C500"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.338 8.667H.69c.055-.264.114-.528.177-.792 0 0 1.028-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.691 1.263 4.447 1.728 5.476 6.646 5.476 6.646.06.252.118.505.17.758ZM.682 23.333H31.31a29.56 29.56 0 0 1-.177.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124a25.83 25.83 0 0 1-.184-.79Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 13.333c.368 0 .667.299.667.667v7.333h.666V22H2.666v-.667h.667V14c0-.368.299-.667.667-.667Zm1.667.334H13v5.778c0 1.994-1.642 2.888-3.667 2.888s-3.667-.894-3.667-2.888v-5.778Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.333 13.333c1.841 0 3.334-.746 3.334-1.666 0-.92-1.493-1.667-3.334-1.667C7.493 10 6 10.746 6 11.667c0 .92 1.492 1.666 3.333 1.666ZM4 14c.368 0 .666-.15.666-.333 0-.184-.298-.334-.666-.334-.369 0-.667.15-.667.334 0 .184.298.333.667.333Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E94B35",
    d: "M6 14h3.333v3.333H6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 17.333h3.333v2.334a1.667 1.667 0 1 1-3.333 0v-2.334Z",
    fill: "#F2C500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.333 17.333h3.333v2.334a1.667 1.667 0 1 1-3.333 0v-2.334Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.666 13.333c.368 0 .667.299.667.667v7.333H16V22h-2.667v-.667H14V14c0-.368.298-.667.666-.667Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.667 14c.368 0 .666-.15.666-.333 0-.184-.298-.334-.666-.334-.368 0-.667.15-.667.334 0 .184.299.333.667.333ZM11 17c.552 0 1-.597 1-1.333 0-.737-.448-1.334-1-1.334s-1 .597-1 1.334c0 .736.448 1.333 1 1.333Z",
    fill: "#E94B35"
  }));
};

export default SvgSpa;